import Constants from '../utils/constants';

export default {
    types: [
        {
            id: Constants.MODAL_TYPE.BASE,
            open: false
        },
        {
            id: Constants.MODAL_TYPE.ON_CLOSE,
            open: false
        },
        {
            id: Constants.MODAL_TYPE.FEEDBACK,
            open: false
        },
        {
            id: Constants.MODAL_TYPE.SELECT.ADC,
            open: false
        },
        {
            id: Constants.MODAL_TYPE.SELECT.DRIVER,
            open: false
        }
    ],
    config: {
        default: {
            title: '',
            body: '',
            type: Constants.MODAL_TYPE.BASE,
            size: 'md',
            handleOnClose: null,
            analyticMessage: 'dialogViewed'
        },
        about: {
            title: 'icon_modal.about_help.title',
            body: 'icon_modal.about_help.body',
            analyticMessage: 'helpViewed'
        },
        browserIssue: {
            title: 'modal.browserIssue.title',
            body: 'modal.browserIssue.body',
            analyticMessage: 'browserIssueViewed'
        },
        feedback: {
            title: 'icon_modal.feedback.title',
            type: Constants.MODAL_TYPE.FEEDBACK,
            size: 'sm',
            analyticMessage: 'feedbackViewed'
        },
        videos: {
            title: 'icon_modal.video.title',
            body: 'icon_modal.video.body',
            analyticMessage: 'videosViewed'
        },
        adcSelect: {
            type: Constants.MODAL_TYPE.SELECT.ADC
        },
        driverSelect: {
            type: Constants.MODAL_TYPE.SELECT.DRIVER
        }
    },
    qaAttrValues: {
        adc_input: 'adc_and_settings',
        driver_input: 'driver_and_settings',
        filter_input: 'filter_settings',
        ac_input_signal: 'ac_input_settling_simulation',
        dc_input_signal: 'dc_input_settling_simulation',
        input_signal_input: 'input_signal_settings',
        multiplexed: 'multiplexed_input',
        optional_source_settings: 'src_setting_info',
        thd: 'thd_help'
    }
}